module.exports = __webpack_public_path__ + "img/product3.594b348b.png";